import React from 'react';
import { OrderHistoryEntry } from '../customerDetailsTypes';
import styles from './OrderHistoryCard.module.css';

interface OrderHistoryCardProps {
  entries: OrderHistoryEntry[];
}

export const OrderHistoryCard: React.FC<OrderHistoryCardProps> = ({ entries }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.title}>Order History</h3>
        <span className={styles.headerIcon}>📋</span>
      </div>
      <div className={styles.list}>
        {entries.map((entry) => (
          <div key={entry.id} className={styles.row}>
            <div>
              <p className={styles.orderId}>{entry.orderId}</p>
              <p className={styles.daysAgo}>{entry.daysAgo}</p>
              <span className={styles.statusBadge}>{entry.status}</span>
            </div>
            <div className={styles.right}>
              <p className={styles.amount}>{entry.amount}</p>
              <p className={styles.itemCount}>{entry.itemCount}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
